<template>

<div ref="whole_page">
  <div style="padding: 0px 0px 18px 0px">
    <div class="vx-row">
        <vx-input-group class="vx-col xl:w-1/3 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full smalldowndrop">
          <template slot="prepend">
            <div class="prepend-text school-primary_gradient">
              <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
            </div>
          </template>
          <v-select
            id="moduledropdown"
            ref="moduledropdown"
            class="w-full style-chooser-light"
            placeholder="Search / Select a Modules"
            :options="modules"
            v-model="moduleDropdown"
            style="height: 50px;"
            :clearable="false"
            @search:blur="getBackpackForModule"
          />
      </vx-input-group>    
    </div> 
  </div>
  <div class="vx-row">
    <div id="backpackview-contents-container" class="vx-col xl:full-width lg:full-width md:full-width sm-full-width w-1/2">
      <div id="backpacknote-inner-components-container" style="border-radius: 5px">
        <div style="text-align: center;">
          <h4 class="mb-4">Contents</h4>
        </div>
        <div class="vx-col w-full mb-2 mt-2">
          <vs-table class="vs-con-loading__container" ref="backpackDocsTable" single max-items="10" @selected="openSelectedTask" pagination search :data="backpackDocs">
            <template slot-scope="{data}">
              <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data" class="rowcolor">
                <vs-td>
                  <img v-if="file.taskTypeId == 2" src="../../assets/images/video-icon.png" height="40px" >
                  <img v-else-if="file.taskTypeId == 4" src="../../assets/images/presentation-icon.png" height="40px" >
                  <img v-else src="../../assets/images/document-icon.png" height="40px">
                </vs-td>
                <vs-td :data="data[indextr].taskName">
                  <p class="product-name font-medium">{{file.taskName}}</p>
                </vs-td>
                <vs-td>
                  <vs-button color="#727272" type="flat" icon-pack="feather" icon="icon-send" @click.stop="emailTask(file.fileUrl)"></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
    <div id="backpackview-contents-container" class="vx-col xl:full-width lg:full-width md:full-width sm-full-width w-1/2">
      <div id="backpacknote-inner-components-container" style="border-radius: 5px">
        <div v-show="notesMode == 'list'">
          <div style="text-align: center;">
            <h4 class="mb-4">Notes</h4>
          </div>
          <div class="vx-col w-full mb-2 mt-2">
            <vs-table class="vs-con-loading__container" ref="backpackNotesTable" id="backpack-notes-table" single max-items="10" pagination search @selected="editNote" :data="backpackNotes">
              <div slot="header">
                <div>
                  <vs-button @click="addNewNote" :disabled="isDisabled" color="success" type="flat" icon-pack="feather" icon="icon-plus" text-color="#28C76F">Add Note</vs-button>
                </div>
              </div>
              <template slot-scope="{data}">
                <vs-tr :data="note" :key="indextr" v-for="(note, indextr) in data" class="rowcolor">
                  <vs-td>
                    <img src="../../assets/images/note-icon.png" height="40px" >
                  </vs-td>
                  <vs-td :data="data[indextr].title">
                    <p class="product-name font-medium">{{note.title}}</p>
                  </vs-td>
                  <vs-td>
                    <vs-button color="#727272" type="flat" icon-pack="feather" icon="icon-mail"></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div v-show="notesMode == 'addedit'">
          <div style="text-align: center;">
            <h4 class="mb-4">{{ noteHeading }}</h4>
          </div>
          <div class="vx-col w-full mb-2 mt-2">
            <label>Title</label>
              <vs-input id="backpacknote-title" autocomplete="off" v-validate="'required'" v-model="noteData.title" class="w-full mb-3"/>
            <label>Content</label>
              <quill-editor class="transparentBackpack-bg" v-model="noteData.body" :options="editorOption" />
          </div>
          <div class="vx-row mt-4">
            <vs-spacer></vs-spacer>
            <div class="vx-col">
              <vs-button size="small" color="success" type="filled" class="mr-3 mb-2 vs-con-loading__container" ref="saveNoteButton" :disabled="!noteData.title" @click="saveNote">Save</vs-button>
              <vs-button size="small" color="danger" type="filled" v-show="noteData.id" class="mr-5 mb-2 vs-con-loading__container" @click="deleteNote" ref="deleteNoteButton">Delete</vs-button>
              <vs-button size="small" color="warning" type="filled" class="mb-2" @click="closeNote">Cancel</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

import vSelect from 'vue-select';

export default {
  components: {
      quillEditor,
      vSelect
    },
    data(){
      return{
        editorOption: {
          modules: {
            toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
          },
        },
        backpackDocs: [],
        backpackNotes: [],
        notesMode: "list",
        noteHeading: "",
        noteData: {
          id: 0,
          studentId: 0,
          moduleId: 0,
          title: "",
          body: ""
        },
        moduleDropdown: 0,
        modules: [],
        studentId: 0,
        isDisabled: false,
        selectedModule: 0
      };
    },
    methods:{
      openSelectedTask(task) {
        var self = this;

        if(task.taskTypeId == 4){
          window.open(task.presentationUrl);
        }
        else if(task.taskTypeId == 5){
          window.open(task.fileUrl);
        }
        else{
          if(task.sceneId){
            window.open('../digi/story?mode=previewScene&sceneId=' + task.sceneId, "_blank");
          }else
            self.preview(task);
        }
      },
      showLoadingOnBackpackDocsTable(){
        var self = this;
        self.$vs.loading({
          color: "#727272",
          type: "corners",
          container: self.$refs.backpackDocsTable.$el,
          scale: 1
        });
      },
      showLoadingOnBackpackNotesTable() {
        var self = this;
        self.$vs.loading({
          color: "#727272",
          type: "corners",
          container: self.$refs.backpackNotesTable.$el,
          scale: 1
        });
      },
      addNewNote() {
        var self = this;
        self.notesMode = "addedit";
        self.noteHeading = "New Note";
      },
      editNote(note) {
        var self = this;
        self.notesMode = "addedit";
        self.noteHeading = "Edit Note";
        self.noteData.id = note.id;
        self.noteData.title = note.title;
        self.noteData.body = note.body;
      },
      saveNote() {
        this.$validator.validateAll().then(result => {
          var self = this;

          if (result) {
            self.showLoadingOnSaveNoteButton();
            self.noteData.studentId = self.studentId;
            self.noteData.moduleId = self.moduleDropdown.value;

            var onSuccess = response => {
              self.initNoteValues();
              self.getBackpackNotes();
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Note Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function (){
              self.$vs.loading.close(self.$refs.saveNoteButton.$el);
            };

            self.$ajaxPost(self, "Student/AddEditNote", self.noteData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteNote() {
        var self = this;
        self.showLoadingOnDeleteNoteButton();

        var onSuccess = response => {
          self.initNoteValues();
          self.getBackpackNotes();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Note Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteNoteButton.$el);
        };

        self.$ajaxDelete(self, "Student/DeleteNote/" + self.noteData.id, onSuccess, onFinally);
      },
      closeNote() {
        this.initNoteValues();
      },
      initNoteValues() {
        var self = this;
        self.notesMode = "list";
        self.noteData.id = 0;
        self.noteData.studentId = 0;
        self.noteData.moduleId = 0;
        self.noteData.title = "";
        self.noteData.body = "";
      },
      initValues(){
        self.moduleDropdown = 0;
        self.studentId = 0;
        self.isDisabled = false;
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      preview(task){
        this.$router.push({ name: "VideoViewer", query: { id: task.taskId, moduleId: task.moduleId, styleB: false, taskClassificationTypeId: 9 }});
      },
      showLoadingOnBackpackDocsTable(){
        var self = this;
        self.$vs.loading({
          color: "#727272",
          type: "corners",
          container: self.$refs.backpackDocsTable.$el,
          scale: 1
        });
      },
      getBackpackForModule(){
        var self = this;        
        if(self.moduleDropdown && self.moduleDropdown != self.selectedModule){
          self.getBackpackDocuments();
          self.getBackpackNotes();

          self.isDisabled = false;

          self.selectedModule = self.moduleDropdown;
        }
      },
      getBackpackDocuments() {
        var self = this;

        self.showLoadingOnBackpackDocsTable();

        var onSuccess = function (response) {

          self.backpackDocs = response.data;
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.backpackDocsTable.$el);
        };

        self.$ajaxGet(self, "student/getbackpackcontent?studentId=" + self.studentId + "&moduleId=" + self.moduleDropdown.value, onSuccess, onFinally);
      },
      getBackpackNotes() {
        var self = this;
        self.showLoadingOnBackpackNotesTable();

        var onSuccess = function (response) {
          self.backpackNotes = response.data;
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.backpackNotesTable.$el);
        };

        self.$ajaxGet(self, "Student/GetNotes?studentId=" + self.studentId + "&moduleId=" + self.moduleDropdown.value, onSuccess, onFinally);
      },
      showLoadingOnBackpackNotesTable() {
        var self = this;
        self.$vs.loading({
          color: "#727272",
          type: "corners",
          container: self.$refs.backpackNotesTable.$el,
          scale: 1
        });
      },
      showLoadingOnSaveNoteButton() {
        var self = this;
        self.$vs.loading({
          type: "material",
          container: self.$refs.saveNoteButton.$el,
          scale: 0.30
        });
      },
      showLoadingOnDeleteNoteButton() {
        var self = this;
        self.$vs.loading({
          type: "material",
          container: self.$refs.deleteNoteButton.$el,
          scale: 0.30
        });
      },
    },
    mounted() {
      var self = this;
      self.studentId = localStorage.getItem("Current_User_Id");
      self.modules = JSON.parse(localStorage.getItem("StudentModules"));

      self.modules = Array.from(new Set(self.modules.map(x => x.value)))
                    .map(value => {return{label: self.modules.find(x => x.value == value).label,
                    value: value}});

      self.isDisabled = true;  
    }
}


</script>

<style lang="scss">

#backpackview-contents-container {
  position: unset !important;
}

#backpackview-contents-container {
  z-index: 1;
  position: absolute;
  display: block;
  text-align: left;
  left: 25px;
  right: 0;
}

.style-chooser-light .selected-tag{
  font-size: medium !important;
}

@media screen and (max-width: 830px) {
  .stack-divs {
    display: block !important;
  }

  .sm-full-width {
    width: 100% !important;
  }

  #backpackview-contents-container,
  #backpackview-notes-container {
    position: unset !important;
  }

  #backpacknote-inner-components-container {
    width: 100% !important;
  }

  #backpack-contents-container.w-1\/2 {
    width: 48.5% !important;
  }

  #backpackview-notes-container.w-1\/2 {
    width: 48.5% !important;
  }

  .dropdown-toggle {
    width: 100% !important;
    min-width: 100% !important;
    font-size: small !important;
  }

  .style-chooser-light .selected-tag{
    font-size: small !important;
  }
}

@media screen and (max-width: 500px) {
  .smalldowndrop{
    width: 100% !important;
  }

  .style-chooser-light .selected-tag{
    font-size: small !important;
    position: absolute;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis !important;
    max-width: 90%;
  }

  .dropdown-toggle{
    max-height: 50px;
  }

  .open{
    .style-chooser-light .selected-tag{
      font-size: small !important;
      position: absolute;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis !important;
      max-width: 90%;
    }

    .dropdown-toggle{
      max-height: 50px;
    }
  }
}

.transparentBackpack-bg {
  background-color:  rgba(0, 0, 0, 0.4) !important;
}

.transparentBackpack-bg_black {
  background-color: rgba(0, 0, 0, 0.4) !important;
}

#backpacknote-title {
  background: rgba(0, 0, 0, 0.4) !important;
  color: #ebeefd !important
}

#backpacknote-inner-components-container {
  border-radius: 5px;
  text-align: left;
  width: 100%;
  padding: 10px;
  bottom: 0;
  display: inline-block;
  position: relative;
  margin-bottom: 10px;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, .25);
}

#moduledropdown {
  .vs__actions {
    display: contents !important;

    .open-indicator {
      margin-right: 10px !important;
    }
  }
}

#backpack-notes-table{
  .input-search{
    width: 100%;
  }
}

</style>